/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosTrxCountInfo = {
    TP: AptosTrxCountInfo.TP;
    CNT: string;
};

export namespace AptosTrxCountInfo {

    export enum TP {
        ALL = 'ALL',
        USER_TRANSACTION = 'USER_TRANSACTION',
        NON_USER_TRANSACTION = 'NON_USER_TRANSACTION',
    }


}

